import { Component, OnInit, ElementRef, ViewChild, ViewEncapsulation, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'app-view-column',
  templateUrl: './view-column.component.html',
  styleUrls: ['./view-column.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
  
})
export class ViewColumnComponent implements OnInit {
  // ---------- Child Elements ----------
  @ViewChild('viewColumn', {static: false }) viewColumn: ElementRef<HTMLDivElement>;
  
  
  
  // ---------- Input / Ouput ----------
  @Input()
  unpadded = false;



  // ---------- Lifecyle Events ----------
  constructor() { }

  ngOnInit() {
  }


  
  // ---------- Utility ----------
  /**
   * Mobile devices have variable viewheight because the browser bar can scroll in and out of view
   * This workaround determines the available window space and uses that as a viewheight unit
   */
  updateViewHeight() {
    const vh = window.innerHeight * 0.01;
    this.viewColumn.nativeElement.style.setProperty('--vh', `${vh}px`);
  }
}
